module.exports = __webpack_public_path__ + "static/media/IMG-2.a1f6e13e.jpg";